import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ViewModeType } from '@/domain/value_objects/config/viewModeType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ConfigStateModuleName } from '@/store/modules/modules'

export class ConfigStateViewModel {
  private store = useStore()

  viewMode: ComputedRef<ViewModeType> = computed(() => this.store.getters[`${ConfigStateModuleName}/viewMode`])
  displayLanguage: ComputedRef<DisplayLanguageType> = computed(
    () => this.store.getters[`${ConfigStateModuleName}/displayLanguage`]
  )
  programLanguage: ComputedRef<ProgramLanguageType> = computed(
    () => this.store.getters[`${ConfigStateModuleName}/programLanguage`]
  )
  editorFontSize: ComputedRef<number> = computed(() => this.store.getters[`${ConfigStateModuleName}/editorFontSize`])

  windowWidth: ComputedRef<number> = computed(() => this.store.getters[`${ConfigStateModuleName}/windowWidth`])
  windowHeight: ComputedRef<number> = computed(() => this.store.getters[`${ConfigStateModuleName}/windowHeight`])

  setViewMode(viewMode: ViewModeType): void {
    this.store.commit(`${ConfigStateModuleName}/setViewMode`, { viewMode })
  }

  setDisplayLanguage(displayLanguage: DisplayLanguageType): void {
    this.store.commit(`${ConfigStateModuleName}/setDisplayLanguage`, { displayLanguage })
  }

  setProgramLanguage(programLanguage: ProgramLanguageType): void {
    this.store.commit(`${ConfigStateModuleName}/setProgramLanguage`, { programLanguage })
  }

  setEditorFontSize(editorFontSize: number): void {
    this.store.commit(`${ConfigStateModuleName}/setEditorFontSize`, { editorFontSize })
  }

  updateWindowSize(): void {
    this.store.dispatch(`${ConfigStateModuleName}/updateWindowSize`)
  }
}
